import config from '@/config';
import { FunctionalitiesEnum } from '@/config/types';
import { getSpecialRoutePath } from '@/logic/main/utils';
import MessageBus from '@/ports-frontend/MessageBus';
import Window from '@/ports-frontend/Window';

export async function personalizedBannerWatcher({
  callback,
}: {
  callback: Function;
}) {
  const unsubscribePersonalizedBannersUpdate = await MessageBus.onSubscribe(
    ({
      payload,
    }: {
      payload: { banners: { container: string; rendered: boolean }[] };
    }) => {
      callback({
        type: 'PERSONALIZED_BANNERS_UPDATED',
        payload,
      });
    },
    ['wh.common.event.ui.promotion.banners.flow.start']
  );

  const unsubscribePersonalizedBannersClick = await MessageBus.onSubscribe(
    ({
      payload,
    }: {
      payload: {
        slug: string;
        isPersonalizedBanner: boolean;
        path: string;
      };
    }) => {
      const shouldRedirectToPromotionPageOnSports =
        config.features.basecampBannersStaticRedirect.mode === 'enabled';
      if (shouldRedirectToPromotionPageOnSports) {
        const url = `${
          config.features.basecampBannersStaticRedirect.redirectUrl
        }${getSpecialRoutePath(FunctionalitiesEnum.promotions)}/offer/${
          payload.slug
        }`;
        Window.redirectToUrl(url);
      } else {
        callback({
          type: 'VIEW_CATEGORY_ROUTE_ITEM_CLICK',
          payload: {
            ...payload,
            isPersonalizedBanner: true,
            path: `/promotions/${payload.slug}`,
          },
        });
      }
    },
    ['wh.common.event.ui.promotion.banners.flow.banner.clicked']
  );

  return () => {
    unsubscribePersonalizedBannersUpdate();
    unsubscribePersonalizedBannersClick();
  };
}

export async function startPersonalizedBanners(
  bannersInfo: { selector: string; slug?: string }[]
) {
  MessageBus.publishEvent({
    topic: 'wh.common.command.ui.promotion.banners.flow.start',
    data: {
      banners: bannersInfo
        .map(i => {
          const { selector, ...rest } = i;
          return [
            {
              container: selector,
              banner: rest,
            },
            {
              container: selector + `_clone`,
              banner: rest,
            },
          ];
        })
        .flat(),
    },
  });
}
